import { Box } from "@mui/material";
export default function LoafBadge({ label = "Ready" }) {
  return (
    <Box
      sx={{
        display: "inline-block",
        border: "1px solid rgba(255,255,255,.24)",
        borderRadius: 999,
        px: 1.25,
        py: 0.5,
        fontSize: 12,
        opacity: 0.9,
      }}
    >
      {label}
    </Box>
  );
}
